module.exports = __webpack_public_path__ + "img/5.b457ec58.png";